import Icon from '../components/Icon.vue'

Icon.register({
  'glass-whiskey': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 32H32C12.5 32-2.4 49.2 0.3 68.5L56.3 425C60.8 456.5 87.8 479.9 119.7 479.9H392.7C424.5 479.9 451.6 456.5 456.1 425L511.7 68.5C514.4 49.2 499.5 32 480 32zM442.6 96L412.6 288H99.6L69.4 96H442.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass-whiskey.js
// module id = PMpN
// module chunks = 144